import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ProjectSideMenuComponent} from './project-side-menu/project-side-menu.component';
import {ProjectContentComponent} from './project-content/project-content.component';
import {ChapterDescriptionDialogComponent} from './chapter-description-dialog/chapter-description-dialog.component';
import {ActivatedRoute} from '@angular/router';
import {ProjectDataService} from '../../../shared/services/project-data.service';
import {Divider} from 'primeng/divider';

@Component({
  imports: [
    ProjectSideMenuComponent,
    ProjectContentComponent,
    ChapterDescriptionDialogComponent,
    Divider,
  ],
  templateUrl: './project-sequence.component.html',
  styleUrl: './project-sequence.component.scss',
})
export class ProjectSequenceComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly projectDataService = inject(ProjectDataService);

  ngOnInit(): void {
    this.route.data.subscribe(({project}) => {
      if (project) {
        this.projectDataService.setProject(project);
      }
    });
  }

  ngOnDestroy() {
    this.projectDataService.clearProject();
  }
}
